import React from "react";
import {debounce} from "../utils.jsx";

class BusinessSelectField extends waffle.base.BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            businesses: [],
            offset: 0
        };

        this.debouncedBusinessSearch = debounce(() => {
            this.setState({
                offset: 0,
                businesses: []
            }, () => this.searchBusiness());
        }, 500)
    };

    componentDidMount() {
        const businessList = document.querySelector('#business-list');

        businessList.addEventListener('scroll', () => {
            if (businessList.scrollTop + businessList.clientHeight >= businessList.scrollHeight) {
                this.loadMoreResults();
            }
        });
    }

    loadMoreResults() {
        this.state.offset += 10;
        this.searchBusiness(true);
    }

    searchBusiness(append = false) {
        const searchInput = document.getElementById("search-input");

        if (searchInput.value === "") {
            return
        }

        radio('showLoader').broadcast();
        $.ajax({
            url: '/api/businesses/',
            data : {
                businessWithOwnerInfo: true,
                search: searchInput.value,
                offset: this.state.offset
            },
            method: 'GET'
        }).done((response) => {
            radio('hideLoader').broadcast();
            if (response.status === 200) {
                if (append) {
                    this.setState({
                        businesses: this.state.businesses.concat(response.data.businesses)
                    });
                } else {
                    this.setState({
                        businesses: response.data.businesses
                    });
                }
            } else {
                radio('showAlert').broadcast('warning', `Search failed for ${searchInput} (${response.status})`)
            }
        }).fail((response, textStatus) => {
            radio('hideLoader').broadcast();
            radio('showAlert').broadcast('danger', textStatus);
        });
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        } else {
            this.debouncedBusinessSearch()
        }
    }

    handleClickOnBusiness(event) {
        const business = this.state.businesses.find(b => b.uuid === event.target.id);
        document.getElementById("search-input").value = business.name;
        this.props.onFullOptionChanged(business);
        this.setState({
            offset: 0,
            businesses: []
        });
    }

    clear() {
        document.getElementById("search-input").value = "";
        this.setState({
            offset: 0,
            businesses: []
        });
    }

    render() {
        const list = this.state.businesses.map((business, key) =>
            <li key={business.uuid} id={business.uuid} onClick={(event) => this.handleClickOnBusiness(event)}>{business.name}</li>
        );
        return (
            <div>
                <div className="business-select-field">
                    <label htmlFor="search-input">BUSINESS</label>
                    <div className="search-container">
                        <input id="search-input" placeholder="Pick a business..." type="search" onKeyUp={(event) => this.handleKeyPress(event)}/>
                        <span className="business-search-clear" onClick={() => this.clear()}>x</span>
                    </div>
                </div>
                <ul id="business-list">
                    {list}
                </ul>
            </div>
        );
    }
}

module.exports = {
    BusinessSelectField: BusinessSelectField
}